var React = require('react');

function AddMedium (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.107 11.429h4.822c.591 0 1.071.48 1.071 1.071v.536c0 .591-.48 1.071-1.071 1.071h-4.822v4.822c0 .591-.48 1.071-1.071 1.071H12.5c-.592 0-1.071-.48-1.071-1.071v-4.822H6.07c-.591 0-1.071-.48-1.071-1.071V12.5c0-.592.48-1.071 1.071-1.071h5.358V6.07c0-.591.48-1.071 1.071-1.071h.536c.591 0 1.071.48 1.071 1.071v5.358z","fill":"currentColor","fillRule":"evenodd"}));
}

AddMedium.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = AddMedium;

AddMedium.default = AddMedium;
